import React from 'react';
import './PartnersSection.scss';

const PartnersSection = () => {
  const partners = [
    { name: 'Guesty', logo: '/images/partners/guesty.webp' },
    { name: 'Smiling House', logo: '/images/partners/smilinghouse.webp' },
    { name: 'Swistainable', logo: '/images/partners/swistainable.webp' },
    { name: 'Invenio', logo: '/images/partners/logoinv.webp' }
  ];

  return (
    <div className="partners-section">
      <div className="container">
        <h3 className="partners-title">Partnering with</h3>
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div key={index} className="partner-item">
              <img 
                src={partner.logo} 
                alt={partner.name}
                className="partner-logo"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersSection;